import React, { useContext } from 'react';

import { ProfileApi } from '../apis';
import { api } from '../api';

const ProfileApiContext = React.createContext(new ProfileApi(api));

export const ProfileApiProvider = ProfileApiContext.Provider;
export const useProfileApi = (): ProfileApi => useContext(ProfileApiContext);
